import Translator from "../../../requests/apa/Translator";
import Utils from "../../../utils/Utils";

export const initGetDataFromApa = () => {
    NOW_EVENT_TAG = Translator.get('playingLive_eventType_description_presentEvent_label ','AHORA');
    NEXT_EVENT_TAG = Translator.get('playingLive_eventType_description_futureEvent_label ','MÁS TARDE');
    PREVIOUS_EVENT_TAG = Translator.get('playingLive_eventType_description_pastEvent_label ','YA EMITIDO');
    NOW_EVENT_TAG_COLOR = Translator.get('playingLive_eventType_description_presentEvent_background', '#EB0045');
    NEXT_EVENT_TAG_COLOR = Translator.get('playingLive_eventType_description_futureEvent_background', '#3F9321');
    PREVIOUS_EVENT_TAG_COLOR = Translator.get('playingLive_eventType_description_pastEvent_background', '#FF6800');
}

export let NOW_EVENT_TAG = 'AHORA';
export let NEXT_EVENT_TAG =  'MÁS TARDE';
export const FOR_LATE_EVENT_TAG = 'MÁS TARDE'; // ya no se utiliza
export const EVENT_ALREADY_STREAMED_TAG = 'YA EMITIDO'; // ya no se utiliza
export let PREVIOUS_EVENT_TAG =  'YA EMITIDO';

export let NOW_EVENT_TAG_COLOR = '#EA0045';
export let NEXT_EVENT_TAG_COLOR = '#3F9320';
export let PREVIOUS_EVENT_TAG_COLOR = '#FF6800';

export const PAST_EVENTS = 'PAST_EVENTS';
export const CURRENT_EVENTS = 'CURRENT_EVENTS';
export const NEXT_EVENTS = 'NEXT_EVENTS';



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/Helpers/Constans.js